import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: '0px 4px 14px rgba(151, 149, 149, 0.04)',
    padding: '50px 0 0',
    position: 'relative',
    zIndex: 10,
    overflow: 'hidden',
    borderRadius: '20px 20px 0 0',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0 30px'
    }
  },
  container: {
    maxWidth: 1440,
    margin: '0 auto',
    padding: '0 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '0 16px'
    }
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 60,
    [theme.breakpoints.down('sm')]: {
      gap: 40
    }
  },
  iconLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 52,
    height: 52,
    borderRadius: '50%',
    color: theme.palette.background.default,
    transition: 'transform 0.2s ease',
    '&:hover': {
      transform: 'scale(1.06)'
    },
    [theme.breakpoints.down('sm')]: {
      width: 40,
      height: 40
    },
    '& img': {
      width: 30,
      height: 30,
      [theme.breakpoints.down('sm')]: {
        width: 30,
        height: 30
      }
    }
  },
  logosWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 50,
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      gap: 15
    },
    '& img': {
      height: 52,
      maxWidth: 160,
      objectFit: 'contain',
      transition: 'transform 0.2s ease',
      '&:hover': {
        transform: 'scale(1.05)'
      },
      [theme.breakpoints.down('sm')]: {
        height: 25,
        maxWidth: 100
      }
    },
    '& img[src*="lsbd"], & img[alt*="LSBD"], & img[alt*="lsbd"]': {
      height: 43,
      maxWidth: 130,
      [theme.breakpoints.down('sm')]: {
        height: 20,
        maxWidth: 90
      }
    }
  },
  copyright: {
    textAlign: 'center',
    lineHeight: 1.5,
    maxWidth: 700,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7rem',
      padding: '0 10px'
    }
  }
}))
